import React, {useEffect, useRef, useState} from "react";
import Table from "../../components/Table";
import {defaultData} from "./Data.js";
import style from "./GameField.module.css"
import SideBar from "../../components/SideBar";
import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import * as UserService from "../../api/UserService";
import * as GameService from "../../api/GameService";
import useWebSocket from "react-use-websocket";
import {useEffectOnce} from "../../hooks/useEffectOnce";
import DiceComponent from "./DiceComponent";
import GameNotFound from "./GameNotFound";
import Draggable from 'react-draggable';
import ReorderOutlinedIcon from '@mui/icons-material/ReorderOutlined';
import GameFieldOffcanvas from "../../components/GameFieldOffcanvas";
import {verifyLogin} from "../../api/UserService";
import MetaphoricCardsModal from "../../components/methaphoricCards/MetaphoricCardsModal";
import PayGame from "../../components/PayGame";
import {Button, ModalBody, ModalFooter, ModalHeader, ModalTitle, OverlayTrigger, Tooltip} from "react-bootstrap";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import ChangeVideoModal from "./ChangeVideoModal";
import {trySetTimeout} from "../../hooks/trySetTiemout";
import LoginModal from "../../components/LoginPage/LoginModal";
import DialogComponent from "../../components/DialogComponent";
import InstagramWarning from "../../components/InstagramWarning";
import {useTranslation} from "react-i18next";
import TranslationSwitch from "../../translation/translationSwitch";
import GameFieldOffCanvasTimer from "../../components/GameFieldOffCanvasTimer";
import Modal from "react-bootstrap/Modal";
import {wsBaseUrl} from "../../api/ApiUtils";

export default function GameField(props) {
    const {t, i18n} = useTranslation('translation', {keyPrefix: 'gameField'});
    const [playerPos, setPlayerPos] = useState(0)
    const [gameState, setGameState] = useState()
    const [gameSuccessfullyFetched, setGameSuccessfullyFetched] = useState(undefined)
    const [myCards, setMyCards] = useState()
    const [onVideoCall, setOnVideoCall] = useState()
    const [isDiceHorizontal, setDiceHorizontal] = useState(true)
    const [gameFieldStyle, setGameFieldStyle] = useState(undefined)

    const gameLastUpdate = useRef()

    const defaultStyle = {
        "background_img_url": "https://leelaonline-web-assets.s3.eu-north-1.amazonaws.com/game_field_calm.png",
        "background_colors": "#aaacba, #aaacba, #7a7e98, #263076"
    }

    const [showCanvas, setShowCanvas] = useState(false)
    const [loginValid, setLoginValid] = useState(false)
    const [showMetaphoricCardsModal, setShowMetaphoricCardsModal] = useState(false)
    const [selectedMetaphoricCardStackData, setSelectedMetaphoricCardStackData] = useState()
    const [showChangeVideoModal, setShowChangeVideoModal] = useState(false)
    const [showReloginModal, setShowReloginModal] = useState(false)
    const [showLoginModal, setShowLoginModal] = useState(false)
    const [queryParams] = useSearchParams()

    const params = useParams()

    const {
        sendJsonMessage,
        lastJsonMessage,
        readyState
    } = useWebSocket(wsBaseUrl + `ws/game/${params.id}/stream`, {
        shouldReconnect: () => true,
        share: true
    });

    function pullCards() {
        UserService.getAllMentorCardsByGameId(params.id, setMyCards, () => setGameSuccessfullyFetched(false))
    }

    function checkIfReloginNeeded() {
        if (!loginValid && (queryParams.get("player") === null)) {
            setShowReloginModal(true)
        } else {
            setShowReloginModal(false)
        }
    }

    useEffect(() => {
        checkIfReloginNeeded()
    }, [gameState, loginValid])

    useEffect(() => {

        if (lastJsonMessage?.message === "new user move") {
            callGameState()
        }

        if (lastJsonMessage?.message?.type === "game_redirect" && lastJsonMessage?.message?.game_id !== undefined) {
            if (onVideoCall) {
                nav(`/game/${lastJsonMessage.message.game_id}?autovideo=on`)
            } else {
                nav(`/game/${lastJsonMessage.message.game_id}`)
            }
        }

        if (lastJsonMessage?.message?.name === "cards" && !loginValid) {
            setShowMetaphoricCardsModal(true)
            setSelectedMetaphoricCardStackData(lastJsonMessage?.message?.stack_data)
        }

        if (lastJsonMessage?.message?.name === "force_reload") {
            window.location.reload()
        }

    }, [lastJsonMessage]);

    function closeMethaphoricalCardModal() {
        setShowMetaphoricCardsModal(false)
    }

    function handleUserPosition() {
        if (gameState?.last_action && gameState?.last_action !== "move") {
            setPlayerPos(gameState.current_user_position)
        } else if (gameState?.last_step_moves === 1) {
            setPlayerPos(gameState.current_user_position)
        } else if (gameState?.last_step_moves === 2) {
            setPlayerPos(gameState.steps[0].from_position)
            trySetTimeout(() => {
                setPlayerPos(gameState.current_user_position)
            }, 2500)
        } else {
            setPlayerPos(gameState !== undefined ? gameState?.current_user_position : 0)
        }
    }

    useEffect(() => {
        handleUserPosition()
    }, [gameState])

    const nav = useNavigate()

    function callGameState() {
        UserService.getCurrentGame(params.id, (state) => {
            setGameState(state)
            gameLastUpdate.current = state?.modified
            setGameSuccessfullyFetched(true)
            document.title = "Ліла [" + state.player_name + "] - гра що змінює життя."
        }, (response) => {
            if (response.status === 404) {
                setGameSuccessfullyFetched(false)
            } else {
                window.alert(t('couldNotGetGameError'))
                setGameSuccessfullyFetched(false)
            }

        })
    }

    function callGameStyle() {
        UserService.getCurrentGameStyle(params.id,
            (style) => setGameFieldStyle(style),
            () => {
                console.error("failed to fetch game style, setting default")
                setGameFieldStyle(defaultStyle)
            }
        )
    }

    useEffect(() => {
        callGameState()
    }, [params.id])

    useEffect(() => {
        verifyLogin(setLoginValid)
    }, [gameState])

    useEffectOnce(() => {
        pullCards()
        callGameStyle()
    }, []);

    useEffect(() => {
        const intervalId = setInterval(() => {
            try {
                GameService.getCurrentGameCached(params.id, (state) => {
                    if (gameLastUpdate.current !== state.modified) {
                        setGameState(state)
                        gameLastUpdate.current = state.modified
                    }

                }, (error) => {
                    console.error("Cached game call failed", error)
                })
            } catch (e) {
                console.log(e)
            }
        }, 10000)
        return () => {
            clearInterval(intervalId)
        }
    }, [])

    function GameFieldStyle() {
        return Object.assign(
            {
                display: "grid",
                gridTemplateColumns: "5fr 3fr",
                paddingLeft: "5px",
                paddingRight: "25px",
                paddingTop: "0px",
                paddingBottom: "0px",
                height: "100%",
                backgroundImage: "linear-gradient(to right," + gameFieldStyle.background_colors + ")"
            }
        )
    }

    function GameFieldStyleImage() {
        return Object.assign(
            {
                width: gameFieldStyle.background_img_width,
                height: gameFieldStyle.background_img_height,
                paddingTop: gameFieldStyle.padding_top,
                paddingLeft: gameFieldStyle.padding_left,
                backgroundRepeat: "no-repeat",
                backgroundSize: "contain",
                backgroundImage: "url(" + gameFieldStyle.background_img_url + ")"
            }
        )
    }

    const nodeRef = useRef()

    const changeVideo = () => {
        return (
            <OverlayTrigger
                placement="bottom"
                delay={{show: 400, hide: 50}}
                overlay={renderTooltip(t('problemsWithVideoPush'))}
            >
                <ErrorOutlineOutlinedIcon fontSize={"medium"} style={{marginTop: "12px", color: "red"}}
                                          onClick={() => setShowChangeVideoModal(true)}></ErrorOutlineOutlinedIcon>
            </OverlayTrigger>
        )
    }

    function renderTooltip(text) {
        return (<Tooltip id="button-tooltip">
            {text}
        </Tooltip>)
    }

    function sendReloadMessage() {
        sendJsonMessage({message: {name: "force_reload"}})
    }

    function updateVideoType() {
        UserService.changeVideoType(
            params.id,
            () => {
                sendReloadMessage()
            }, () => {
            })
    }

    return (
        <>
            <InstagramWarning/>
            {gameSuccessfullyFetched === true && gameFieldStyle &&
                <div className={style.container}>
                    <div style={new GameFieldStyle()} id={"boundaries"}>
                        <div className={style.fieldContainer}>
                            {gameState.require_payment && <PayGame
                                gameId={gameState.id}
                                createdInFreeTier={gameState.created_in_free_tier}
                                isMentor={loginValid}
                            />}
                            <div style={new GameFieldStyleImage()}>
                                <Table tbodyData={defaultData}
                                       cards={myCards || ""}
                                       currentUserCell={playerPos}
                                       playerName={gameState?.player_name || ""}
                                       fieldStyle={gameFieldStyle}
                                       gameState={gameState}
                                       loginValid={loginValid}
                                />
                            </div>
                        </div>

                        <div className={style.sideBarWithCanvas}>
                            <div className={style.sideBar}>
                                {!gameState?.is_over && !gameState.require_payment &&
                                    <Draggable
                                        nodeRef={nodeRef}
                                        axis="both"
                                        handle=".handle"
                                        defaultPosition={{x: 0, y: 350}}
                                        scale={1}
                                        bounds="#boundaries"
                                    >
                                        <div ref={nodeRef} style={{
                                            position: "absolute",
                                            zIndex: 1500,
                                            width: gameState?.is_auto_dice ? 140 : isDiceHorizontal ? 400 : 145
                                        }}>
                                            <DiceComponent is_auto_dice={gameState?.is_auto_dice}
                                                           setGameState={setGameState}
                                                           isDiceHorizontal={isDiceHorizontal}
                                                           setDiceHorizontal={setDiceHorizontal}
                                                           gameState={gameState}/>
                                        </div>
                                    </Draggable>
                                }
                                <div>
                                    <SideBar loginValid={loginValid}
                                             playerPos={playerPos}
                                             gameId={params.id}
                                             gameState={gameState}
                                             cards={myCards || ""}
                                             updateGameState={callGameState} setOnVideoCall={setOnVideoCall}/>
                                </div>
                            </div>
                            <div>
                                <div style={{marginTop: "10px", marginRight: "6px", color: "white"}}>
                                    <TranslationSwitch></TranslationSwitch>
                                </div>

                                {loginValid &&
                                    <div>
                                        <ReorderOutlinedIcon
                                            style={{
                                                marginTop: "12px",
                                                color: "white"
                                            }}
                                            onClick={() => setShowCanvas(true)}></ReorderOutlinedIcon>
                                        {changeVideo()}
                                        {showCanvas && <GameFieldOffcanvas show={showCanvas}
                                                                           onClose={setShowCanvas}
                                                                           gameId={params.id}
                                                                           selfGame={gameState.is_self_game}
                                                                           setShowMetaphoricCardsModal={setShowMetaphoricCardsModal}
                                                                           setSelectedMetaphoricCardStackData={setSelectedMetaphoricCardStackData}
                                                                           cards={myCards || {}}
                                                                           gameState={gameState}

                                        />}
                                    </div>
                                }
                            </div>
                        </div>

                    </div>

                </div>
            }
            {
                gameSuccessfullyFetched === false && <GameNotFound callGameState={callGameState} pullCards={pullCards}/>
            }
            {
                showMetaphoricCardsModal && <MetaphoricCardsModal
                    selectedStackData={selectedMetaphoricCardStackData}
                    modalOpened={showMetaphoricCardsModal}
                    closeModal={closeMethaphoricalCardModal}
                    gameId={params.id}></MetaphoricCardsModal>
            }
            {
                showChangeVideoModal && <ChangeVideoModal changeVideo={updateVideoType}
                                                          closeModal={() => setShowChangeVideoModal(false)}></ChangeVideoModal>
            }
            {
                showReloginModal && gameSuccessfullyFetched &&
                <Modal
                    show={showReloginModal && gameSuccessfullyFetched}
                    onHide={() => {
                    }}
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <ModalHeader>
                        <ModalTitle>{t('mentorViewOpened')}</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        <span>{t('loginAsHost')}</span>
                        <br/>
                        <span>{t('pageReloadsAutomatically')}</span>
                        <br/>
                        <span>{t('proceedToPlayersView')}</span>
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            variant="primary"
                            active={true}
                            onClick={() => {
                                window.location.href += "?player"
                            }}>
                            {t('proceedAsPlayer')}
                        </Button>
                        <Button
                            variant="info"
                            onClick={() => {
                                setShowLoginModal(true)
                                setShowReloginModal(false)
                            }}
                        >{t('loginAsMentor')}</Button>
                    </ModalFooter>
                </Modal>
            }
            {
                showLoginModal && <LoginModal
                    closeModal={() => {
                        setShowLoginModal(false)
                        setShowReloginModal(true)
                    }
                }
                    reloadPage={() => sendReloadMessage()}
                ></LoginModal>
            }
            {readyState === 3 && <DialogComponent
                title={t('noConnectionServerLost')}
                hideCancelButton={true}
                onConfirm={() => window.location.reload()}
                agreeButtonText={t('reloadThePage')}

            />}
            {loginValid && <GameFieldOffCanvasTimer game_id={params.id}/>}

        </>

    );
}